<template>
  <header class="web-header">
    <div class="container">
      <div class="header-content">
        <div class="logo-container">
          <a href="/" class="logo-link">
            <img src="@/assets/logo.png" alt="安徽经纶瑞恒医药科技有限公司" class="logo-image">
          </a>
        </div>

        <nav class="desktop-nav">
          <a href="#about" class="nav-link">关于我们</a>
          <span class="nav-separator"></span>
          <a href="#features" class="nav-link">企业特色</a>
          <span class="nav-separator"></span>
          <a href="#culture" class="nav-link">企业文化</a>
          <span class="nav-separator"></span>
          <a href="#team" class="nav-link">团队风采</a>
          <span class="nav-separator"></span>
          <a href="#patientRegistration" class="recruitment-button" >患者报名</a>
          <span class="nav-separator"></span>
          <a href="#recruitment" class="recruitment-button" >系统搭建</a>
        </nav>

        <div class="mobile-menu-toggle">
          <button
            type="button"
            class="menu-toggle-button"
            @click="toggleMenu"
            aria-label="菜单"
          >
            <i v-if="isMenuOpen" class="menu-close-icon"></i>
            <i v-else class="menu-open-icon"></i>
          </button>
        </div>
      </div>
    </div>
    <!-- 移动端导航菜单 -->
    <div
      v-if="isMenuOpen" 
      class="mobile-nav"
      :class="{ 'mobile-nav-open': isMenuOpen }"
    >
      <div class="mobile-nav-container">
        <a href="#about" class="mobile-nav-link" @click="closeMenu">关于我们</a>
        <a href="#features" class="mobile-nav-link" @click="closeMenu">企业特色</a>
        <a href="#culture" class="mobile-nav-link" @click="closeMenu">企业文化</a>
        <a href="#team" class="mobile-nav-link" @click="closeMenu">团队风采</a>
        <a href="#patientRegistration" class="mobile-nav-link" @click="closeMenu">患者报名</a>
        <a href="#recruitment" class="mobile-nav-link" @click="closeMenu">系统搭建</a>
      </div>
    </div>
  </header>
</template>

<script setup>
import { ref } from 'vue'

const isMenuOpen = ref(false)
// const emit = defineEmits(['form-select'])

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value
  // 控制页面滚动
  document.body.style.overflow = isMenuOpen.value ? 'hidden' : ''
}

const closeMenu = () => {
  isMenuOpen.value = false
  document.body.style.overflow = ''
}

// const selectForm = (formType) => {
//   closeMenu()
//   emit('form-select', formType)
// }
</script>

<style scoped>
.web-header {
  position: sticky;
  top: 0;
  z-index: 50;
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid #f3f4f6;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.container {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
  box-sizing: border-box;
}

@media (min-width: 640px) {
  .container {
    padding: 0 1.5rem;
  }
}

@media (min-width: 1024px) {
  .container {
    padding: 0 2rem;
  }
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 3.5rem; /* 移动端导航栏高度减小 */
}

@media (min-width: 768px) {
  .header-content {
    height: 5rem; /* 桌面端恢复高度 */
  }
}

.logo-container {
  display: flex;
  align-items: center;
}

.logo-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.logo-image {
  height: 2.5rem; /* 移动端logo缩小 */
  margin: 0; /* 移除多余margin */
  object-fit: contain; /* 确保logo完整显示 */
}

@media (min-width: 768px) {
  .logo-image {
    height: 3rem; /* 桌面端logo放大 */
  }
}

/* 桌面端导航 */
.desktop-nav {
  display: none; /* 默认隐藏，移动端不显示 */
  align-items: center;
  gap: 1.5rem; /* 减小间距 */
}

@media (min-width: 1024px) { /* 仅在较大屏幕显示桌面导航 */
  .desktop-nav {
    display: flex;
  }
}

.nav-link {
  color: #374151;
  font-weight: 500;
  transition: color 0.2s ease;
  text-decoration: none;
  font-size: 0.95rem; /* 稍小字体 */
  padding: 0.5rem 0;
}

.nav-link:hover {
  color: #2563eb;
}

.nav-separator {
  width: 1px;
  height: 1.5rem;
  background-color: #d1d5db;
  display: none; /* 默认隐藏分隔符 */
}

@media (min-width: 1200px) { /* 仅在大屏幕显示分隔符 */
  .nav-separator {
    display: block;
  }
}

.recruitment-button {
  background-color: #2563eb;
  color: white;
  padding: 0.4rem 1rem; /* 减小按钮内边距 */
  border-radius: 9999px;
  transition: all 0.3s ease;
  font-size: 0.95rem; /* 减小字体 */
  text-decoration: none;
  display: inline-block;
  white-space: nowrap; /* 防止按钮文字换行 */
}

.recruitment-button:hover {
  background-color: #1d4ed8;
  transform: scale(1.05);
}

/* 移动端菜单按钮 */
.mobile-menu-toggle {
  display: block; /* 移动端显示 */
}

@media (min-width: 1024px) {
  .mobile-menu-toggle {
    display: none; /* 桌面端隐藏 */
  }
}

.menu-toggle-button {
  color: #374151;
  transition: color 0.2s ease;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 0.25rem;
}

.menu-toggle-button:hover {
  color: #2563eb;
  background-color: #f3f4f6;
}

.menu-toggle-button:focus {
  outline: 2px solid rgba(37, 99, 235, 0.2);
  outline-offset: 2px;
}

.menu-close-icon::before,
.menu-open-icon::before {
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
  font-size: 1.5rem; /* 增大图标 */
}

.menu-close-icon::before {
  content: "\f00d";
}

.menu-open-icon::before {
  content: "\f0c9";
}

/* 移动端导航菜单 */
.mobile-nav {
  display: none;
  background-color: white;
  border-top: 1px solid #f3f4f6;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 40;
}

.mobile-nav-open {
  display: block;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.mobile-nav-container {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0.75rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  box-sizing: border-box;
}

@media (min-width: 640px) {
  .mobile-nav-container {
    padding: 0.75rem 1.5rem;
  }
}

.mobile-nav-link {
  display: block;
  padding: 0.75rem 0.5rem;
  color: #374151;
  font-weight: 500;
  text-decoration: none;
  border-radius: 0.25rem;
  transition: all 0.2s ease;
}

.mobile-nav-link:hover {
  color: #2563eb;
  background-color: #f9fafb;
}

.mobile-recruitment-button {
  display: block;
  text-align: center;
  background-color: #2563eb;
  color: white;
  padding: 0.75rem;
  border-radius: 9999px;
  transition: all 0.2s ease;
  text-decoration: none;
  font-weight: 500;
  margin-top: 0.25rem;
}

.mobile-recruitment-button:hover {
  background-color: #1d4ed8;
  transform: translateY(-2px);
}

/* 针对小屏手机的优化 */
@media (max-width: 360px) {
  .header-content {
    height: 3rem;
  }
  
  .logo-image {
    height: 2rem;
  }
  
  .recruitment-button {
    padding: 0.35rem 0.85rem;
    font-size: 0.9rem;
  }
  
  .mobile-nav-link,
  .mobile-recruitment-button {
    padding: 0.65rem 0.5rem;
    font-size: 0.9rem;
  }
}
</style>